import subgroupsService from './subgroupsService';

export * from './utils';
export * from './types';
export default subgroupsService;



// WEBPACK FOOTER //
// ./src/services/subgroups/index.ts